<template>
    <div class="flex" :class="{ 'items-center': singleLine }" @click="toggleCheck()">
        <div>
            <div class="w-5 h-5 border rounded-full flex justify-center items-center cursor-pointer bg-white" :class="[borderColorComputed]">
                <div v-if="check" class="w-3 h-3 bg-a-orange-fe5000 rounded-full"></div>
            </div>
        </div>
        <div v-if="text != null" class="pl-2 text-14 cursor-default" v-html="text"></div>
        <div v-else class="pl-2">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "CheckboxCircle",
    props: {
        check: { type: Boolean }, // v-model:check
        text: { type: String, default: null },
        singleLine: {
            type: Boolean,
            default: true
        },
        borderColor: {
            type: String,
            default: "gray"
        }
    },
    computed: {
        borderColorComputed: function () {
            if (this.borderColor == "orange") {
                return "border-a-orange-fe5000"
            }
            return "border-a-gray-d8d8d8"
        }
    },
    emits: ["update:check"],
    methods: {
        toggleCheck: function () {
            let value = !this.check;
            this.$emit('update:check', value);
        },
    },
}
</script>

